// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Italy */
const IT = /^(?:3[2-9]\d{7,8}|(?:31|43)\d{8})$/;

export default IT;
